/**
 * Marketing-site constants, substituted into the static pages at build time by the
 * `siteConstants` plugin in vite.config.ts (`%SITE_BRAND%`, `%SITE_EMAIL%`, …).
 * The single place to change the brand name or the contact address on the website.
 */
export const SITE = {
  BRAND: 'RoomTour',
  /** Domain bought 2026-10-03; create the mailbox before launch (Apple needs a real contact). */
  EMAIL: 'hola@roomtourapp.com',
  /** Canonical origin, used ONLY for the absolute URLs that must be absolute:
   *  `<link rel="canonical">` and the hreflang alternates of the static pages. */
  ORIGIN: 'https://roomtourapp.com',
  /** "Última actualización" / "Last updated" on the legal pages (es / en). */
  LEGAL_UPDATED: '2 de noviembre de 2026',
  LEGAL_UPDATED_EN: '2 November 2026',
  YEAR: '2026',
  /** The public App Store page (live since 2026-10-15). No storefront in the path, so
   *  Apple opens the visitor's own. Empty would bring back the "Próximamente" badges. */
  APP_STORE_URL: 'https://apps.apple.com/app/roomtour-tour-virtual-360/id6818844806',
  /** App Store Connect provider token (`pt=`) for campaign links: ASC → Analytics →
   *  Campaigns → generate any campaign link and copy its pt. Empty = links carry only
   *  `ct`, which Apple ignores, so web downloads stay unattributed until it's set.
   *  See src/site/appStore.ts and docs/WEB_LAYER.md → "App Store attribution". */
  APP_STORE_PT: '',
  /** Default social preview image (public/og-roomtour.jpg, 1200×630, ≤300 KB for WhatsApp). */
  OG_IMAGE: '/og-roomtour.jpg',
} as const;
